module.exports = __webpack_public_path__ + "static/media/Mapa-São Paulo.00106694.svg";